import { ProjectType } from "./Types";
import { useBackendApi } from "./backendApi";
import { useEventsPublisher } from 'event-bus';
import { useSetupAreaIdContext } from './SetupAreaIdContext';

export const PROJECT_COMMISSION_FIELD_UPDATED = 'PROJECT_COMMISSION_FIELD_UPDATED';

export function useProjectCommissionFieldService() {
  const backendApi = useBackendApi();

  const eventsPublisher = useEventsPublisher();

  const context = useSetupAreaIdContext();

  const getSetupAreaIdParams = (setupAreaId?: number | string) => {
    setupAreaId = setupAreaId || context?.setupAreaId;

    if (setupAreaId) {
      return `?setupAreaId=${setupAreaId}`;
    }
    return '';
  }

  const updateIsCommissionField = async (
    projectType: ProjectType,
    fieldId: number,
    isCommissionField: boolean,
    setupAreaId?: number | string,
  ) => {
    await backendApi.put(`/settings/projects/${projectType.toLowerCase()}/detailfields/${fieldId}/commissionfield${getSetupAreaIdParams(setupAreaId)}`, {
      isCommissionField,
    });
    eventsPublisher.publish(PROJECT_COMMISSION_FIELD_UPDATED, {
      projectType,
    });
  };

  return {
    updateIsCommissionField,
  }
}
